export default "__VITE_ASSET__5727360d__"